export const getPaginatedArray = (pageSize, dataArray, page) => {
  page = parseInt(page)? page : 1;
  const dataLength = dataArray.length;
  const maxPageCount = Math.ceil(dataLength / pageSize);
  const pageToFetch = page <= maxPageCount ? page : maxPageCount;
  const startIndex = page == 1 ? 0 : pageSize * (pageToFetch - 1);
  const endIndex = startIndex + pageSize < dataLength ? startIndex + pageSize : dataLength;
  console.log("start", startIndex, "end", endIndex, "pageSIze", pageSize);
  return dataArray.slice(startIndex, endIndex);
};





// WEBPACK FOOTER //
// ./src/components/utils/helpers.js